import { formatInTimeZone } from 'date-fns-tz';
import _ from 'lodash';
import { getConfig } from '../AppConfig';

import getOrderFilterOptions, {
  toBusinessTimezone,
} from './GetOrderFilterOptions';
import { isValidTimezone } from './businessTimezone';

const getNearestTime = (date, time, orderType, restaurantDetails = null) => {
  const config = getConfig();
  const oType = orderType?.value;
  if (
    !['takeout', 'delivery'].includes(oType) ||
    !isValidTimezone(config?.timezone)
  ) {
    return null;
  }

  const isASAP = !_.isObject(time) || time?.type === 'asap';
  if (
    !isASAP &&
    (!Number.isInteger(date?.dayOfMonth) ||
      date.dayOfMonth < 1 ||
      date.dayOfMonth > 31 ||
      !Number.isFinite(Number(time?.value?.start)))
  ) {
    return null;
  }

  const monthDayNumber = isASAP
    ? parseInt(formatInTimeZone(toBusinessTimezone(), config.timezone, 'd'), 10)
    : date.dayOfMonth;
  const { timeOptions } = getOrderFilterOptions(restaurantDetails, {
    dayKey: monthDayNumber,
    mode: oType,
  });

  let result = null;

  if (isASAP === true) {
    const intervals = timeOptions?.[monthDayNumber]?.[oType];

    result = intervals?.[0] ?? null;
  } else {
    const intervals = timeOptions?.[date.dayOfMonth]?.[oType] ?? [];

    // first search for one interval containing the previous selection
    for (let index = 0; index < intervals.length; index++) {
      const interval = intervals[index];
      if (
        interval.value.start <= time.value.start &&
        interval.value.end > time.value.start
      ) {
        result = interval;
        break;
      }
    }

    // if no interval contains it, then select the first one available after that
    if (result === null) {
      let diff = null;
      for (let index = 0; index < intervals.length; index++) {
        const interval = intervals[index];
        if (time.value.start <= interval.value.start) {
          const localDiff = interval.value.start - time.value.start;
          if (diff === null) {
            result = interval;
            diff = localDiff;
          } else if (localDiff < diff) {
            result = interval;
            diff = localDiff;
          }
        }
      }
    }
  }

  return result;
};

export default getNearestTime;
